module.exports = __webpack_public_path__ + "img/xml.94127870.svg";